import { useEffect, useState } from 'react';

export const useAnchor = () => {
  const [anchor, setAnchor] = useState('');

  useEffect(() => {
    const anchorId = window.location.hash.slice(1).split('?')[0];
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setAnchor(anchorId);

    return () => setAnchor('');
  }, []);

  return anchor;
};
